var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.966,
    height: 12.062,
    viewBox: "0 0 10.966 12.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Forma_1",
    "data-name": "Forma 1",
    d: "M2.181,12.062a.464.464,0,0,1-.458-.431L.96,2.756H0V1.811H3.21V.787A.779.779,0,0,1,3.978,0h3.01a.779.779,0,0,1,.768.787V1.811h3.21v.945H9.99l-.762,8.875a.466.466,0,0,1-.459.431Zm.422-.944H8.348l.718-8.361H1.885ZM6.835,1.811V.945h-2.7v.866Zm-.23,7.9.2-5.59.921.034-.2,5.59ZM3.241,4.159l.921-.034.2,5.59-.92.034ZM5.023,9.732V4.14h.921V9.732Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.7714faf6f7042f1699151c9a0190aa02.svg";
export { ForwardRef as ReactComponent };